const defaultFilterValues = {
  modelClass: null,
  company_id: null,
  department: null,
  division: null
};

export default {
  name: 'MailRecipientConfig',
  data () {
    return {
      loading: true,
      currentReq: null,
      tableItems: [],
      modelClasses: [],
      filterValues: this.BasicHelper.cloneObject(defaultFilterValues),
      tableSorting: { },
      paging: { limit: 20, page: 1, total: 0, pages: 0 },
      isMounted: false
    };
  },
  computed: {
    tableActions () {
      return { filters: true, reload: true }
    },
    userCompanies () {
      return this.BasicHelper.sortArrayByKeyValue(
        this.$store.getters.getConfigOptions('user_companies', this.$i18n.locale, 'disabled', '0'),
        'text'
      );
    },
    companyDepartments () {
      return this.$store.getters.getConfigOptions('company_departments', this.$i18n.locale)
        .filter(
          el => !this.filterValues.company_id || parseInt(el.value) === parseInt(this.filterValues.company_id)
        );
    },
    companyDivisions () {
      return this.companyDepartments
        .filter(
          el => parseInt(el.value) === parseInt(this.filterValues.department_id)
        );
    },
    modelClassesOptions () {
      return Object.entries(this.modelClasses).map(([id, val]) => ({
        code: Number(id),
        text: val[this.$i18n.locale]
      }));
    },
    tableHeaders () {
      const headers = [
        { key: 'model_class', label: this.$t('menu.mail-recipient-config.model_class'), type: 'slot', slotcode: 'modelClass', filterKey: 'modelClass' },
        { key: 'modelElementName', label: this.$t('menu.mail-recipient-config.model_element') },
        { key: 'company_id', label: this.$t('menu.mail-recipient-config.company'), format: 'formatFunc', funcs: [this.getCompanyName], filterKey: 'company_id' },
        { key: 'department_id', label: this.$t('menu.mail-recipient-config.department'), format: 'formatFunc', funcs: [this.getDepartmentName], filterKey: 'department' },
        { key: 'division_id', label: this.$t('menu.mail-recipient-config.division'), format: 'formatFunc', funcs: [this.getDivisionName], filterKey: 'division' },
        { key: 'recipient', label: this.$t('menu.mail-recipient-config.recipient'), type: 'slot', slotcode: 'recipient' },
        { key: 'mail_message', label: this.$t('menu.mail-recipient-config.message_code'), type: 'slot', slotcode: 'mailMessage', filterKey: 'mailMessageCode' }
      ];
      return headers;
    },
    tableFilterConfig () {
      const filters = { };
      filters.modelClass = { type: 'select', options: this.modelClassesOptions, colOnlyFilter: true };
      filters.company_id = { type: 'select', options: this.userCompanies, colOnlyFilter: true, valueField: 'value' };
      filters.department = { type: 'text', colOnlyFilter: true };
      filters.division = { type: 'text', colOnlyFilter: true };
      filters.mailMessageCode = { type: 'text', colOnlyFilter: true };
      return filters;
    },
    requestPath () {
      let path = this.ApiRequest.addGetParamsToPath('mail-recipient-config/?perPage=' + this.paging.limit + '&page=' + this.paging.page, this.filterValues, true);
      if (this.tableSorting.item) {
        path += '&order=' + this.tableSorting.item + ',' + this.tableSorting.direction;
      }
      return path;
    }
  },
  methods: {
    editItem (el) {
      // this.$refs.editElFrm.show(el);
    },
    getCompanyName (id) {
      return id ? this.$store.getters.getParamFromConfig('user_companies', id, 'name', this.$i18n.locale) : null;
    },

    getDepartmentName (id) {
      return id ? this.$store.getters.getParamFromConfig('company_departments', id, 'name', this.$i18n.locale) : null;
    },

    getDivisionName (id) {
      return id ? this.$store.getters.getParamFromConfig('company_divisions', id, 'name', this.$i18n.locale) : null;
    },
    getRecipient (recipient = null) {
      if (!recipient) {
        return;
      }
      if (recipient.fullname) {
        return `${recipient.fullname} (${recipient.email})`;
      } else if (recipient.email) {
        return recipient.email;
      } else if (recipient.type) {
        return this.$t('menu.mail-recipient-config.recipient-types.' + recipient.type);
      }
    },
    getTableData () {
      if (this.currentReq) {
        this.currentReq.cancel('changed search query');
      }
      this.BasicHelper.updateFilterValues(this.$route.name, this.filterValues);
      this.loading = true;
      this.currentReq = this.ApiRequest.request(this.requestPath, this.ApiRequest.REQUEST_GET, {}, (response) => {
        if (response.data) {
          this.tableItems = response.data.items;
          this.modelClasses = response.data.model_classes;
          this.paging = response.paging;
          this.loading = false;
        }
      });
    },
    clearFilters () {
      this.filterValues = this.BasicHelper.cloneObject(defaultFilterValues);
      this.getTableData();
    },
    changePage (pageNr) {
      this.paging.page = pageNr;
      this.getTableData();
    },
    updateFilter (key, value) {
      if (this.filterValues[key] !== value) {
        this.filterValues[key] = this.BasicHelper.cloneObject(value);
        this.paging.page = 1;
        this.getTableData();
      }
    }
  },
  mounted () {
    this.filterValues = this.BasicHelper.fillFilterValues(this.$route.name, this.filterValues, this.$session);
    this.getTableData();
    this.isMounted = true;
  }
}
